export default __webpack_public_path__ + "static/media/paid.d55cd417.png";